var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"data":_vm.tableData,"options":_vm.listDataOptions,"align":"center"}}),_c('Pagination',{attrs:{"pageData":_vm.initParam,"total":_vm.total,"pageSizes":[10, 15, 25, 50]},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }